(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("React"), require("_"), require("axios"), require("ReactDOM"));
	else if(typeof define === 'function' && define.amd)
		define("pro-gallery-renderer", ["React", "_", "axios", "ReactDOM"], factory);
	else if(typeof exports === 'object')
		exports["pro-gallery-renderer"] = factory(require("React"), require("_"), require("axios"), require("ReactDOM"));
	else
		root["pro-gallery-renderer"] = factory(root["React"], root["_"], root["axios"], root["ReactDOM"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_2__, __WEBPACK_EXTERNAL_MODULE_7__, __WEBPACK_EXTERNAL_MODULE_30__, __WEBPACK_EXTERNAL_MODULE_114__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition